import React, { Component } from 'react';
import Cards from 'react-credit-cards';
// import CreditCardInput from 'react-credit-card-input';
import CreditCardInput from './card-input-lib';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Button from 'react-validation/build/button';
import 'react-credit-cards/es/styles-compiled.css';
import { dependencies } from '../../../../tools/Dependencies';
import './card.css';
const required = (value) => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return <div className="alert alert-danger fieldErrorMessage" role="alert"> This field is required.</div>;
  }
};
class card extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cardNumber: '',
            cardHolderName: '',
            expiry: '',
            cvc: '',
            focus: '',
            card_error: false,
            card_complate: false,
            saveCard: true,
            amount: null,
            currency: null,
            card_token: ""
        };
    }
    componentDidMount(){
        try{
            const data = dependencies.decodePaymentToken(this.props.payment_token)
            const amount = ['JOD', 'OMR', 'KWD'].includes(data.currency) ? (data.amount_cents / 1000).toFixed(2) : (data.amount_cents / 100).toFixed(2);
            if(data.token){
                this.setState({amount, currency: data.currency, card_token: data.token, cardNumber: data.masked_pan, expiry: "xx/xx", cardHolderName: "xxxx xxxx"}, ()=> {
                    document.getElementById("card-number").disabled = true;
                    document.getElementById("card-expiry").disabled = true;
                    document.getElementById("cardHolderInput").disabled = true;
                    document.getElementById("cvc").focus();
                })
            }else{
                this.setState({amount, currency: data.currency})
            }
        }catch{
            console.log("invalid payment token")
        }
    }
    handleCardNumberChange = (e) => {
        this.setState({cardNumber: e.target.value, card_error: false},() => {
            this.check_card_complate()
        });
    }
    handleCardExpiryChange = (e) => {
        this.setState({expiry: e.target.value, card_error: false},() => {
            this.check_card_complate()
        });
    }
    handleCardCVCChange = (e) => {
        this.setState({cvc: e.target.value, card_error: false},() => {
            this.check_card_complate()
            if(this.state.cvc.length === 4){
                document.getElementById("cardHolderInput").focus();
            }
        });
    }
    handelCardHolderName = (e) => {
        this.setState({cardHolderName: e.target.value.toUpperCase()},() => {
            this.check_card_complate()
        });
    }
    handelSaveCardChange = (e) => {
        this.setState({saveCard: e.target.checked},() => {
            this.check_card_complate()
        });
    }
    handleInputFocus = (e) => {
        this.setState({ focus: e.target.name });
    }
    check_card_complate = () => {
        if(this.state.card_token){
            if(this.state.cvc.length >= 3){
                this.setState({card_complate: true})
            }else{
                this.setState({card_complate: false})
            }
        }else{
            if(
                (this.state.cardNumber.replace(/ /g,'').length === 15 || this.state.cardNumber.replace(/ /g,'').length === 16) &&
                this.state.expiry.replace(/ /g,'').length >= 5 &&
                this.state.cvc.length >= 3 &&
                this.state.cardHolderName.length >= 1
            ){
                this.setState({card_complate: true})
            }else{
                this.setState({card_complate: false})
            }
        }
    }
    handleSubmit = (e) => {
        e.preventDefault();
        this.handleInputFocus(e);
        let card_data;
        if(this.state.card_token){
            card_data  = {
                "token": this.state.card_token,
                "cvc": this.state.cvc
            }
        }else{
            card_data  = {
                "number": this.state.cardNumber,
                "cardNumber": this.state.cardNumber.replace(/ /g,''),
                "name": this.state.cardHolderName,
                "expiry": this.state.expiry.replace(/ /g,''),
                "expiry_mm": this.state.expiry.replace(/ /g,'').slice(0, 2),
                "expiry_yy": this.state.expiry.replace(/ /g,'').slice(-2),
                "cvc": this.state.cvc,
                "save_card": this.state.saveCard
            }
        }
        this.props.card_submit(card_data)
    }
    render() {
        return (
            <div className={this.props.waiting ? "iframeCardNew ele_blur" : "iframeCardNew"}>
                <div>
                    <Cards
                        cvc={this.state.cvc}
                        expiry={this.state.expiry.replace(/ /g,'')}
                        focused={this.state.focus}
                        name={this.state.cardHolderName}
                        number={this.state.cardNumber}
                    />
                    <CreditCardInput
                        onError={({ inputName, err }) => {this.setState({card_error: true})}}
                        cardNumberInputProps={{ 
                            autoFocus: this.state.card_token == "" ? false : true,
                            name: "number",
                            value: this.state.cardNumber, 
                            disabled: this.props.waiting,
                            onChange: this.handleCardNumberChange, 
                            onFocus: this.handleInputFocus
                        }}
                        cardExpiryInputProps={{ 
                            name: "expiry",
                            value: this.state.expiry, 
                            disabled: this.props.waiting,
                            onChange: this.handleCardExpiryChange, 
                            onFocus: this.handleInputFocus 
                        }}
                        cardCVCInputProps={{ 
                            name: "cvc",
                            value: this.state.cvc, 
                            disabled: this.props.waiting,
                            onChange: this.handleCardCVCChange, 
                            onFocus: this.handleInputFocus 
                        }}
                        fieldClassName="input"
                    />
                    <Form onSubmit={this.handleSubmit}>
                        <div className="newInput">
                            <Input 
                                id="cardHolderInput"
                                type="text" 
                                name="name" 
                                placeholder="Card Holder Name"
                                autoComplete="off"
                                value={this.state.cardHolderName}
                                disabled={this.props.waiting}
                                onChange={this.handelCardHolderName}
                                onFocus={this.handleInputFocus}
                                validations={[required]} 
                            />
                        </div>
                        {this.props.can_save_card && this.props.can_save_card === true &&
                            <div class="disclaimer">
                                <p>your card data will be saved for future installments</p>
                            </div>
                        }
                        {this.props.user_can_save_card && !this.state.card_token &&
                            <div class="form-group accept-terms">
                                <input 
                                    type="checkbox" 
                                    id="save-card"
                                    disabled={this.props.waiting}
                                    checked={this.state.saveCard}
                                    onChange={this.handelSaveCardChange}
                                />
                                <label for="save-card">Save card for future use</label>
                            </div>
                        }
                        <div className='text-center newCardFooter'>
                            {this.props.waiting ? 
                                <button className="newCardButton" disabled><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div> </button> 
                            : 
                                this.state.card_error || !this.state.card_complate ?
                                    this.state.amount != null && this.state.currency != null ?
                                        <button className="newCardButton" disabled>PAY {this.state.amount} {this.state.currency}</button>
                                    :
                                        <button className="newCardButton" disabled>PAY NOW</button>
                                :
                                    this.state.amount != null && this.state.currency != null ?
                                        <Button className="newCardButton">PAY {this.state.amount} {this.state.currency}</Button>
                                    :
                                        <Button className="newCardButton">PAY NOW</Button>
                            }
                            <div className="secured_by">
                                <i className="fa fa-lock"></i>
                                Secured by Paymob
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}

export default card;